export class TripPaymentFilter{
    clientId?: number;
    tripId?: number;
    paymentType?: string;
    remarks?: string;
    checkDueDateFrom?: string;
    checkDueDateTo?: string;
    dateRecieved?: string;
    containerNumber?: string;
    
    
    createdDate?: string; // mm/dd/yyyy

    constructor(){
        this.checkDueDateFrom = null;
        this.checkDueDateTo = null;
        this.dateRecieved = null;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/trips/trip.payment.filter.ts